var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "display-flex" }, [
    _c("span", [_vm._v(_vm._s(_vm.text))]),
    _vm._v(" "),
    _vm.useTooltip
      ? _c(
          "span",
          {
            directives: [
              {
                name: "clipboard",
                rawName: "v-clipboard",
                value: { copyText: _vm.text },
                expression: "{ copyText: text }"
              },
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: _vm.$t("COPY"),
                expression: "$t('COPY')"
              }
            ],
            staticClass: "m-l-5",
            attrs: { placement: "right" }
          },
          [
            _c("i", {
              staticClass: "typcn typcn-tabs-outline clickable f-s-16"
            })
          ]
        )
      : _c(
          "span",
          {
            directives: [
              {
                name: "clipboard",
                rawName: "v-clipboard",
                value: { copyText: _vm.text },
                expression: "{ copyText: text }"
              }
            ],
            staticClass: "m-l-5",
            attrs: { placement: "right", title: _vm.$t("COPY") }
          },
          [
            _c("i", {
              staticClass: "typcn typcn-tabs-outline clickable f-s-16"
            })
          ]
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }